/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MultiContract11 } from '../../models/multi-contract-11';

export interface RacesRaceGuidCacheDatatypeDatatypeFromversionFromVersionGet$Params {
  raceGuid: string;
  datatype: string;
  fromVersion: number;
}

export function racesRaceGuidCacheDatatypeDatatypeFromversionFromVersionGet(http: HttpClient, rootUrl: string, params: RacesRaceGuidCacheDatatypeDatatypeFromversionFromVersionGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MultiContract11>>> {
  const rb = new RequestBuilder(rootUrl, racesRaceGuidCacheDatatypeDatatypeFromversionFromVersionGet.PATH, 'get');
  if (params) {
    rb.path('raceGuid', params.raceGuid, {"style":"simple"});
    rb.path('datatype', params.datatype, {"style":"simple"});
    rb.path('fromVersion', params.fromVersion, {"style":"simple"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MultiContract11>>;
    })
  );
}

racesRaceGuidCacheDatatypeDatatypeFromversionFromVersionGet.PATH = '/races/{raceGuid}/cache/datatype/{datatype}/fromversion/{fromVersion}';
